/* eslint-disable no-param-reassign */
import { Reducer } from 'redux';
import produce from 'immer';
import { IHealthState, HealthTypes } from './types';

const INITIAL_STATE: IHealthState = {
  data: null,
  haveInsurance: null,
  disabled: false,
  loading: false,
  error: false,
};

const health: Reducer<IHealthState> = (state = INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case HealthTypes.GET_HEALTH_REQUEST: {
        draft.loading = true;
        break;
      }
      case HealthTypes.GET_HEALTH_SUCCESS: {
        draft.data = action.payload.data;
        draft.haveInsurance = true;
        draft.disabled = action.payload.data === null;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case HealthTypes.GET_HEALTH_FAILURE: {
        draft.data = null;
        draft.haveInsurance = action.payload.haveInsurance;
        draft.disabled = false;
        draft.loading = false;
        draft.error = true;
        break;
      }
      default:
        break;
    }
  });
};

export default health;
